import React from 'react';
import Styles from './ChatMessagePane.module.scss';
import { ChatMessagePaneHeader } from '~/components/common/chat/messages/ChatMessagePaneHeader';
import { ChatMessagePaneBodyClient } from '~/components/common/chat/messages/ChatMessagePaneBodyClient';
import { ChatMessagePaneBodyVendor } from '~/components/common/chat/messages/ChatMessagePaneBodyVendor';

type Props = DeepReadonly<{
  isVendor?: boolean;
  isAdmin?: boolean;
  handleTemporaryUnread: (dealId: number) => Promise<void>;
}>;

export const ChatMessagePane: React.FC<Props> = ({
  isVendor = false,
  isAdmin = false,
  handleTemporaryUnread
}: Props) => {
  const [isDisabledUnreadButton, setIsDisabledUnreadButton] =
    React.useState<boolean>(true);
  return (
    <div className={Styles.ChatMessagePane}>
      <ChatMessagePaneHeader
        handleTemporaryUnread={handleTemporaryUnread}
        isAdmin={isAdmin}
        isDisabledUnreadButton={isDisabledUnreadButton}
        isVendor={isVendor}
      />
      {isVendor ? (
        <ChatMessagePaneBodyVendor
          setIsDisabledUnreadButton={setIsDisabledUnreadButton}
        />
      ) : (
        <ChatMessagePaneBodyClient
          setIsDisabledUnreadButton={setIsDisabledUnreadButton}
        />
      )}
    </div>
  );
};
